import { render, staticRenderFns } from "./shapeOptions.vue?vue&type=template&id=3510e4d1&lang=pug&"
import script from "./shapeOptions.vue?vue&type=script&lang=js&"
export * from "./shapeOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports